import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const StickyFooter = ({ children, className }) => {
  const classes = classNames({
    'pro-layout-sticky-footer': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="content">{children}</div>
    </div>
  );
};

StickyFooter.propTypes = propTypes;

export default StickyFooter;
